const appTheme = {
    /**
     * iconSize
     */
    
      iconSize:{
        xxxxs:"12px",
        xxxs:"15px",
        xxs:"18px",
        xs:"21px",
        sm:"25px",
        md:"28px",
        lg:"31px",
        xl:"35px",
        xxl:"39px",
        xxxl:"45px",
        xxxxl:"50px",
        xxxxxl:"100px",
        xxxxxxl:"150px",
        xxxxxxxl:"200px",
      },
    
      /**
       * Font
       */
      font: {
        family: {
         Lato:"Lato",
         SweraDemo: 'SweraDemo',
        },
        weight: {
          light: "300",
          normal: "400",
          bold: "600",
          bolder: "900",
        },
        size: {
          xtiny:'0.5rem',
          tiny: "0.6875rem",
          xxs: "0.8125rem",
          xs: "0.875rem",
          sm: "1rem",
          md: "1.125rem",
          lg: "1.37rem",
          xl: "2.125rem",
          xxl: "2.81rem",
          xxxl: "3.5rem",
        },
        stretch: {
          normal: "normal",
        },
        style: {
          normal: "normal",
        },
        newSize: {
          lg: "22px",
        },
      },
    
      /**
       * Colors
       */
    
      colors: {
          borderImgColor:'linear-gradient(to top, #02f1e4, #02f1e4)',
          navIconbg:'linear-gradient(to top, #00fff0, #00fff0)',
          sectionBg:'#c447c7',
          black:'#000',
          white:'#fff',
          cardBgColor:'#201320',
          cardFontColor:'#5d345d',
          skyColor:'#88fefe',
          green:'#203736',
          yellow:'#fece00',
          pink:'#ff73bc',
          lightGreen:'#3dff8f',
          darkPink:'#a90b56',
          lightblue:'#0049ff',
          lightsky:'#88fefe',
          darkYellow:'#ff9c00',
          darkSectionbg:'#1e001e',
          leftSidebarbg:'#271327',
          lightskyColor:'#00fff0',
          lightpink:'#d559da',
          darkvioletColor:'#4d304d',
          // lightskytextcolor:'#7fc2c9',
          lightskytextcolor:'#fff',
          darkBlack:'#090a19',
          lightTextcolor:'#5ca4ab',
          lightvoiletColor:'#271927',
          lightbrownColor:'#191919',
          lightgreencolor:'#1a2d2d',
          lightblackColor:'#2b2a44',
      },
    
      /**
       * Shadows
       */
      shadows: {
        sm: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        md: "rgba(0, 0, 0, 0.3) 0px 1px 8px 0px",
        lg: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
        xl: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
      },
    
      /**
       * Breakpoints
       */
      screen: {
        xxxs:"440px",
        xxs: "540px",
        xs: "640px",
        sm:'768px',
        md: "1007px",
        lg: "1150px",
        xl: "1230px",
        xxl: "1300px",
      },
    
      /**
       * Spacing
       */
      spacing: {
        none: 0,
        tiny: "7px",
        xxxs: "2px",
        xxs: "5px",
        xs: "10px",
        sm: "20px",
        md: "30px",
        lg: "40px",
        xl: "60px",
        xxl: "120px",
        xxxl: "200px",
      },
      newspacing: {
        none:0,
        xxs: "4px",
        xs: "14px",
        sm: "18px",
        md: "24px",
        lg: "38px",
        xl: "54px",
        xxl: "78px",
      },
    
      /**
       * Radius
       */
      radius: {
        xxs: "4px",
        xs: "8px",
        sm: "12px",
        md: "15px",
        lg: "21px",
        xl: "25px",
        xxl: "29px",
        xxxl:'40px',
        xxxxl:'50px',
      },
      newradius: {
        xxs: "6px",
        xs: "10px",
        sm: "14px",
        md: "18px",
        xl: "24px",
        xxl: "32px",
      },
    
      /**
       * zIndex
       */
      zIndex: {
        xs: 10,
        sm: 20,
        md: 30,
        lg: 40,
        xl: 50,
        xxl: 100,
      },
    
      /**
       * cursor
       */
      cursor: {
        notallowed: "not-allowed",
        pointer: "pointer",
      },
    };

export default appTheme;